import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_ENDPOINT;

const handleLogout = () => {
    localStorage.removeItem('currentUser')
    localStorage.removeItem('token')
    localStorage.removeItem('tabIndex')
    localStorage.clear();
    // Redirect to login page
    window.location.href = '/';
};

// Create an Axios instance
const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add a request interceptor
api.interceptors.request.use(
    (config) => {
        // Get the token from localStorage
        const token = localStorage.getItem('token');

        // If the token exists, add it to the headers
        if (token) {
            config.headers.authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        // Handle the error
        return Promise.reject(error);
    }
);

const handle401Error = (error) => {
    if (error.response && error.response.status === 401) {
        handleLogout();
    }
    return Promise.reject(error);
};

// Add response interceptor to api instance
api.interceptors.response.use(
    (response) => response,
    handle401Error
);

// Mirrors MAX_TEXT_LENGTH in the backend tts controller.
export const TTS_MAX_TEXT_LENGTH = 5000;

export const TtsHandler = {

    // The backend detects the language from the text, so only the text is sent.
    async doGenerateSpeech(payload) {
        try {
            const { data } = await api.post(`tts/speak`, payload);
            return data;
        } catch (error) {
            return error;
        }
    },

}
